<template>
	<div>
		<img src="../../../public/index/B.png" style="width: 100%;"/>
		<br /><br />
		<div style="width: 90%;margin: auto;">
			<h2>{{ $t('lang.UVC_disinfection')}}{{ $t('lang.Robot')}}</h2>
			
			<div slot="header" class="clearfix" style="text-align: left;">
				<div>
					<p class="indent">
						{{ $t('lang.automatic_disinfection')}}
					</p>
				</div>
			</div>
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/uvc/UVC8.png" />
			<img v-show="this.$i18n.locale == 'en'" src="../../../public/pic/product/uvc/UVC81.png" />

			<hr />
			<!--
			<h2>{{ $t('lang.Video_introduction')}}</h2>
			<video width="100%" controls>
				<source src="../../../public/pic/product/fooddelivery/Demo.mp4" type="video/mp4">
				您的浏览器不支持 video 标签。
			</video>
			<hr />
			-->
			<h2 >{{ $t('lang.uvc_title')}}</h2>
			
			<div slot="header" class="clearfix" style="text-align: left;">
				<p class="indent">
				{{ $t('lang.uvc_p')}}
				</p>
			</div>
			<img src="../../../public/pic/product/uvc/UVC3.png" />
			
			<hr />
			<h2 >{{ $t('lang.uvc_title1')}}</h2>
			
			<div slot="header" class="clearfix" style="text-align: left;">
				<p class="indent" style="text-align: justify;">
				{{ $t('lang.uvc_p1')}}
				</p>
			</div>
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/uvc/UVC4.png" />
			<img v-show="this.$i18n.locale == 'en'" src="../../../public/pic/product/uvc/UVC41.png" />
			
			<hr />
			<h2 >{{ $t('lang.uvc_p2')}}</h2>
			
			<div slot="header" class="clearfix" style="text-align: left;">
				<p class="indent">
				{{ $t('lang.uvc_p3')}}
				</p>
			</div>
			<img src="../../../public/pic/product/uvc/UVC5.png" />
			
			<br /><br /><br /><br />
		</div>
	</div>
</template>

<script>
export default {
	head(){
		return {
			title : '紫外灯消毒机器人_深圳全智能机器人科技有限公司 UV disinfection robot_ Shenzhen all intelligent robot technology Co., Ltd',
			keywords : '紫外灯消毒机器人,紫光消毒设备,紫外线消毒机,紫光消毒机器人,空气消毒机,智能紫外线消毒机器人,全智能消毒机器人 。UV lamp disinfection robot, purple light disinfection equipment, UV disinfection machine, purple light disinfection robot, air disinfection machine, intelligent UV disinfection robot, all intelligent disinfection robot',
			description : '深圳全智能机器人科技有限公司研发生产的自动消毒机器人是由人工智能技术公司制造的一种可编程的、最先进的机器人仪器。你可以通过一个简单易用的iPad进行无需人工干预的每晚消毒控制器。浓缩紫外线能有效杀灭细菌等有害微生物，最高消毒率达99.99%。  The automatic disinfection robot developed and produced by Shenzhen all intelligent robot technology Co., Ltd. is a programmable and most advanced robot instrument. You can use an easy-to-use iPad to sterilize the controller every night without human intervention. Concentrated UV can effectively kill bacteria and other harmful microorganisms, and the highest disinfection rate is 99.99%.',
		};
	},
}
</script>

<style scoped>
	p{
		font-size: 15px;
		text-align: justify;/*外部引人入的不生效*/
	}
</style>
